import React, { useEffect, useState } from 'react'
import { Modal, Button, Checkbox, Panel, Alert, Grid, Row, Col, Icon } from 'rsuite'
import { Link } from 'react-router-dom'
import {
  getConfilictOfInterestsSchema,
  getDocumentConfilictOfInterests,
} from '../../redux/actions/conflictOfInterests'
import { doneLoading, startLoading } from '../../utils/loading'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { previewFile } from '../../utils/fileUtil'

export default function CoiApproveProjectWidget({
  disabled = false,
  check = false,
  onCheck = () => {},
  isProposal = false,
  disabledInterest = false,
  checkInterest = false,
  onCheckInterest = () => {},
  fixType,
  isBold,
  ...props
}) {
  const [showCOIDetail, setShowCOIDetail] = useState(false)
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    try {
      const _schema = await getConfilictOfInterestsSchema(fixType)
      console.log('coi => ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.error('error => ', e)
    }
  }

  const handleGetDocumentCoi = async (fileType) => {
    console.log('fileType => ', fileType)
    setIsLoading(true)
    startLoading()
    try {
      let file = ''
      if (fileType == '1') {
        file = 'ประกาศสำนักงานฯ_เรื่องแนวปฏิบัติเกี่ยวกับส่วนได่เสียในกระบวนการสนับสนุนทุน2565.pdf'
      } else {
        file = 'ระเบียบ_การบริหารจัดการโครงการทางอิเล็กทรอนิกส์_2563.pdf'
      }
      var files = await getDocumentConfilictOfInterests(`system-doc/coi/${file}`)

      previewFile(files, file)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'การแสดงไฟล์ ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const readingMore = () => {
    if (fixType != '1' && fixType != '9') {
      return ''
    }

    return (
      <>
        <Grid fluid style={{ padding: 10 }}>
          <Row>
            <Col xs={1} sm={1} md={1} lg={1}></Col>
            <Col xs={23} sm={23} md={23} lg={23} style={{ color: '#2da888' }}>
              <u>โปรดอ่านคำอธิบายและข้อแนะนำ</u>
            </Col>
            <Col xs={1} sm={1} md={1} lg={1}></Col>
            <Col xs={23} sm={23} md={23} lg={23}>
              <Button
                appearance="link"
                onClick={() => {
                  handleGetDocumentCoi(1)
                }}
              >
                <Icon icon="hand-o-right" /> 1.
                ประกาศสำนักงานฯ_เรื่องแนวปฏิบัติเกี่ยวกับส่วนได่เสียในกระบวนการสนับสนุนทุน2565.pdf
              </Button>
            </Col>
            <Col xs={1} sm={1} md={1} lg={1}></Col>
            <Col xs={23} sm={23} md={23} lg={23}>
              <Button
                appearance="link"
                onClick={() => {
                  handleGetDocumentCoi(2)
                }}
              >
                <Icon icon="hand-o-right" /> 2.
                ระเบียบ_การบริหารจัดการโครงการทางอิเล็กทรอนิกส์_2563.pdf
              </Button>
            </Col>
          </Row>
        </Grid>
      </>
    )
  }

  return (
    <div>
      {isLoading && <OverlayLoader />}

      <p style={{ fontWeight: isBold ? 'bold' : undefined }}>{`1. ${schema?.header || ''}`}</p>

      {schema?.forms?.checkConfInterest && (
        <>
          <Checkbox
            onChange={(value, checked) => onCheck(checked)}
            checked={check}
            disabled={disabled}
          >
            {schema.forms.checkConfInterest.label}&nbsp;
          </Checkbox>

          {readingMore()}
        </>
      )}

      {schema?.forms?.checkNoInterest && (
        <>
          <Checkbox
            onChange={(value, checked) => {
              console.log('b => ', checked)
              if (checked) {
                onCheck(checked)
                onCheckInterest(false)
              } else {
                onCheck(false)
              }
            }}
            checked={check}
            disabled={disabled}
          >
            {schema.forms.checkNoInterest.label}
            {fixType != '1' && (
              <Button
                appearance="link"
                onClick={() => {
                  setShowCOIDetail(true)
                }}
                disabled={disabled}
              >
                <Icon icon="info" />
                &nbsp;
                <u style={{ fontWeight: 'bold' }}>โปรดอ่านคำอธิบายและข้อแนะนำ</u>
              </Button>
            )}
          </Checkbox>

          {readingMore()}
        </>
      )}

      {schema?.forms?.checkNoInterestReview && (
        <>
          <Checkbox
            onChange={(value, checked) => {
              console.log('b => ', checked)
              if (checked) {
                onCheck(checked)
                onCheckInterest(false)
              } else {
                onCheck(false)
              }
            }}
            checked={check}
            disabled={disabled}
          >
            {schema.forms.checkNoInterestReview.label}
            {fixType != '1' && (
              <Button
                appearance="link"
                disabled={disabled}
                onClick={() => {
                  setShowCOIDetail(true)
                }}
              >
                <Icon icon="info" />
                &nbsp;
                <u style={{ fontWeight: 'bold' }}>โปรดอ่านคำอธิบายและข้อแนะนำ</u>
              </Button>
            )}
          </Checkbox>

          {readingMore()}
        </>
      )}

      {schema?.forms?.checkInterest && (
        <Checkbox
          onChange={(value, checked) => {
            console.log('c => ', checked)
            if (checked) {
              onCheckInterest(checked)
              onCheck(false)
            } else {
              onCheckInterest(false)
            }
          }}
          checked={checkInterest}
          disabled={disabled}
        >
          {schema.forms.checkInterest.label}
        </Checkbox>
      )}

      <Modal
        full
        backdrop={'static'}
        overflow
        show={showCOIDetail}
        onHide={() => setShowCOIDetail(false)}
      >
        <Modal.Header>
          <Modal.Title>
            <p style={{ paddingTop: '0.5rem' }}>{'คำอธิบายและข้อแนะนำ '}</p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ overflow: 'auto !important' }}>
            <p style={styleHeader}>
              <u>คำอธิบาย</u>
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ข้อบังคับกองทุนสนับสนุนการสร้างเสริมสุขภาพ
              ว่าด้วยหลักเกณฑ์และวิธีการจัดสรรเงินเพื่อการดำเนินงานสร้างเสริมสุขภาพ พ.ศ. 2562
              กำหนดลักษณะการมีส่วนได้เสียของผู้จัดการ และผู้ปฏิบัติงานของ สสส. ในการพิจารณาแผนงาน
              ชุดโครงการ หรือโครงการ ในกรณีดังต่อไปนี้
            </p>

            <ol style={styleOrder}>
              <li>
                ผู้จัดการ และผู้ปฏิบัติงานของ สสส.&nbsp;
                <u style={styleHighLightBlack}>รวมถึงคู่สมรสหรือบุตรที่ยังไม่บรรลุนิติภาวะ</u>&nbsp;
                <u style={styleHighLightRed}>มีความสัมพันธ์ในเชิงบริหารในกิจการของผู้รับทุน</u>
                &nbsp; เช่น การดำรงตำแหน่งเป็นผู้จัดการ หุ้นส่วนผู้จัดการ กรรมการผู้จัดการ ผู้บริหาร
                หรือมีหรือผู้มีอำนาจในการบริหารจัดการกิจการของผู้รับทุน
                รวมถึงการเป็นกรรมการหรือผู้มีอำนาจในการบริหารจัดการกิจการของมูลนิธิ สมาคม
                หรือองค์กรสาธารณประโยชน์ต่าง ๆ ซึ่งเป็นองค์กรผู้รับทุน
              </li>

              <li>
                ผู้จัดการ และผู้ปฏิบัติงานของ สสส.&nbsp;
                <u style={styleHighLightBlack}>รวมถึงคู่สมรสหรือบุตรที่ยังไม่บรรลุนิติภาวะ</u>&nbsp;
                <u style={styleHighLightRed}>มีความสัมพันธ์ในเชิงทุนในกิจการของผู้รับทุน</u>&nbsp;
                เช่น เป็นหุ้นส่วนในห้างหุ้นส่วนสามัญหรือห้างหุ้นส่วนจำกัด
                หรือเป็นผู้ถือหุ้นในบริษัทจำกัดหรือบริษัทมหาชนจำกัด ซึ่งเป็นองค์กรผู้รับทุน
                หรือมีความเป็นเจ้าของในกิจการของผู้รับทุน
              </li>
            </ol>

            <br />

            <p style={styleHeader}>
              <u>ข้อแนะนำ</u>
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในกรณีที่ผู้จัดการและผู้ปฏิบัติงานของ สสส.
              มีส่วนได้เสียเกี่ยวกับแผนงาน ชุดโครงการ หรือโครงการ ให้ปฏิบัติดังนี้
            </p>

            <ol style={styleOrder}>
              <li>กรณีที่ผู้จัดการมีส่วนได้เสีย ให้เสนอคณะกรรมการ สสส. เพื่อพิจารณาแทน</li>

              <li>
                กรณีที่ผู้อำนวยการสำนัก ผู้ช่วยผู้จัดการ หรือรองผู้จัดการ มีส่วนได้เสีย
                ให้เสนอผู้บังคับบัญชาเหนือตน 1 ชั้น (ผู้ช่วยผู้จัดการ รองผู้จัดการ หรือผู้จัดการ
                แล้วแต่กรณี) เพื่อพิจารณาแทน
              </li>

              <li>
                กรณีที่นักวิชาการมีส่วนได้เสีย ให้เสนอผู้อำนวยการสำนัก
                เพื่อพิจารณามอบหมายนักวิชาการอื่นปฏิบัติหน้าที่แทน
              </li>
            </ol>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <Button onClick={() => setShowCOIDetail(false)} ripple appearance="subtle">
              {'ปิด'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

// const msgProposal = `ข้าพเจ้าขอรับรองว่าไม่มีกรรมการ ที่ปรึกษาของคณะกรรมการ กรรมการบริหารแผน อนุกรรมการ กรรมการประเมินผล ผู้จัดการ หรือผู้ปฏิบัติงานของ สสส. มีส่วนได้เสียไม่ว่าโดยทางตรงหรือทางอ้อมในกิจการของผู้รับทุน เว้นแต่กิจการของผู้รับทุนเป็นการดำเนินการโดยหน่วยงานของรัฐ`

// const msgApprover = `ไม่มีส่วนเกี่ยวข้องหรือมีส่วนได้เสียโดยตรงกับผู้เสนอแผนงาน ชุดโครงการ หรือโครงการ รายละเอียดตามข้อ 23 วรรคหนึ่ง ของข้อบังคับกองทุนสนับสนุนการสร้างเสริมสุขภาพว่าด้วยหลักเกณฑ์และวิธีการจัดสรรเงินเพื่อการดำเนินงานสร้างเสริมสุขภาพ พ.ศ. 2562`

// const msgApprover = `ข้าพเจ้าขอรับรองว่าไม่มีกรรมการ ที่ปรึกษาของคณะกรรมการ กรรมการบริหารแผน อนุกรรมการ กรรมการประเมินผล ผู้จัดการ หรือผู้ปฏิบัติงานของ สสส. มีส่วนได้เสียไม่ว่าโดยทางตรงหรือทางอ้อมในกิจการของผู้รับทุน เว้นแต่กิจการของผู้รับทุนเป็นการดำเนินการโดยหน่วยงานของรัฐ`

const styleHeader = {
  textAlign: 'center',
  fontWeight: 'bold',
}

const styleHighLightBlack = {
  fontWeight: 'bold',
}

const styleHighLightRed = {
  color: '#ff0000db',
  fontWeight: 'bold',
}

const styleOrder = {
  marginLeft: 10,
  marginTop: 5,
}
